import { render, staticRenderFns } from "./EditConfigurableSettings.vue?vue&type=template&id=c87ec932&lang=pug&"
import script from "./EditConfigurableSettings.vue?vue&type=script&lang=js&"
export * from "./EditConfigurableSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports